<template>
    <form class="row cSeller g-3" v-on:submit.prevent="SubmitContactSeller">
        <div class="col-md-12">
            <h1 class="pstitle" style="text-align: center">Contact Seller</h1>
        </div>
        <template v-if="this.submitSuccess">
            <div class="col-12">
                <span class="success">{{this.contactSellerSuccess}}</span>
            </div>
        </template>
        <template v-if="this.submitFailure">
            <div class="col-12">
                <span class="failure">{{this.inputFormSubmitFailure}}</span>
            </div>
        </template>
        <div class="row" v-if="!this.submitSuccess">
            <div class="col-md-12">
                <input type="text"
                       class="form-control"
                       id="fname"
                       placeholder=" "
                       v-model="v$.leadObj.firstName.$model"
                       @blur="v$.leadObj.firstName.$touch()" />
                <label for="fname" class="form-label">{{formLabel.firstName}}</label>
                <template v-if="v$.leadObj.firstName.$error">
                    <span v-for="(err, index) in v$.leadObj.firstName.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-md-12">
                <input type="text"
                       class="form-control"
                       id="lname"
                       placeholder=" "
                       v-model="v$.leadObj.lastName.$model"
                       @blur="v$.leadObj.lastName.$touch()" />
                <label for="lname" class="form-label">{{formLabel.lastName}}</label>
                <template v-if="v$.leadObj.lastName.$error">
                    <span v-for="(err, index) in v$.leadObj.lastName.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-md-12">
                <input type="email"
                       class="form-control"
                       id="email"
                       placeholder=" "
                       v-model="v$.leadObj.email.$model"
                       @blur="v$.leadObj.email.$touch()" />
                <label for="email" class="form-label">{{formLabel.email}}</label>
                <template v-if="v$.leadObj.email.$error">
                    <span v-for="(err, index) in v$.leadObj.email.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-md-12">
                <input type="tel"
                       class="form-control"
                       id="phone"
                       placeholder=" "
                       v-model="leadObj.phone" />
                <label for="phone" class="form-label">{{formLabel.phone}}</label>
            </div>
            <div class="col-md-12">
                <input type="text"
                       class="form-control"
                       id="postalCode"
                       placeholder=" "
                       v-model="v$.leadObj.postalCode.$model"
                       @input="checkForDealers" />
                <label for="postalCode" class="form-label">{{formLabel.zipcode}}</label>
                <template v-if="v$.leadObj.postalCode.$error">
                    <span v-for="(err, index) in v$.leadObj.postalCode.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div v-if="this.showDealerSelect" class="col-md-12">
                <SelectOption v-model="selectedDealer"
                              :options="dealerList"
                              @change="selectDealer"
                              id="dealer"
                              class="form-control" />
                <label for="dealer" class="form-label">{{formLabel.dealer}}</label>
                <template v-if="v$.selectedDealer.$error">
                    <span v-for="(err, index) in v$.selectedDealer.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>

            </div>

            <div class="col-md-12">
                <textarea type="text"
                          class="form-control form-textarea"
                          rows="6"
                          id="message"
                          placeholder=" "
                          v-model="v$.leadObj.comments__c.$model"
                          @blur="v$.leadObj.comments__c.$touch()" />
                <label for="message" class="form-label">{{formLabel.message}}</label>
                <template v-if="v$.leadObj.comments__c.$error">
                    <span v-for="(err, index) in v$.leadObj.comments__c.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-12 submission">
                <button type="submit" class="btn-submit" :disabled="isSubmitting">{{formLabel.submit}}</button>
            </div>

            <div class="hidden">
                <input type="hidden"
                       id="CONTACT_SELLER_LEAD_SOURCE"
                       name="CONTACT_SELLER_LEAD_SOURCE"
                       :value="leadSource" />
                <input type="hidden"
                       id="loading-time"
                       name="loading-time"
                       :value="this.unixTimestamp" />
                <input type="text"
                       style="display: none"
                       id="hpValue"
                       name="hpValue"
                       v-model="hpvalue" />
            </div>
        </div>
    </form>
</template>
<script>
    import getEndPoint, { leadAPI, searchAPI } from "../../constants/api.config";
    import { dealerSearchRequest, salesforcelead } from "../../constants/form-model-config";
    import useValidate from "@vuelidate/core";
    import { required, email, helpers } from "@vuelidate/validators";
    import { inputFormSubmitFailure, contactSellerSuccess, formLabel } from '../../constants/labels.config';
    import SelectOption from "../atoms/SelectOption.vue";
//    import LightBox from "../atoms/LightBox.vue"

    const zipOrPostalCode = helpers.regex(/^(\d{5}(-\d{4})?|[A-CEGHJ-NPRSTVXY]\d[A-CEGHJ-NPRSTV-Z] ?\d[A-CEGHJ-NPRSTV-Z]\d)$/)

    export default {
        name: "ContactSeller",
        props: {
            hin: null,
            salesforceId: null,
        },
        components: {
            SelectOption
        },
        data() {
            return {
                v$: useValidate(),
                hpvalue: "",
                requestTime: "",
                leadID: "",
                leadObj: { ...salesforcelead },
                searchRequest: { ...dealerSearchRequest },
                submitSuccess: false,
                submitFailure: false,
                contactSellerSuccess,
                inputFormSubmitFailure,
                isSubmitting:null,
                formLabel,
                isNational: false,
                selectedDealer: "Select Dealer",
                dealerList: [],
                currentBrand: "",
                showDealerSelect: false
            };
        },
        validations() {
            return {
                leadObj:{
                    firstName: {
                        required: helpers.withMessage("First name cannot be empty", required),
                    },
                    lastName: {
                        required: helpers.withMessage("Last name cannot be empty", required),
                    },
                    email: {
                        required: helpers.withMessage("Invalid email address", email),
                    },
                    postalCode: {
                        required: helpers.withMessage("Zip Code can not be empty", required),
                        valueFormat: helpers.withMessage("Invalid format", zipOrPostalCode)
                    },
                    comments__c: {
                        required: helpers.withMessage("Message cannot be empty", required),
                    },
                },
                selectedDealer: {
                    required: helpers.withMessage("Please select a dealer", required),
                }
            };
        },
        mounted() {
            this.isNational = window.IS_NATIONAL;
            this.currentBrand = window.BRAND;
        },
        computed: {
            unixTimestamp: function () {
                return Math.round(new Date().getTime() / 1000);
            },
            leadSource() {
                if(this.isNational)
                {
                    switch(this.currentBrand)
                    {
                        case "mastercraft":
                            return "MC Trader";
                        case "crest":
                            return "CR Trader";
                        default:
                            return "Contact Seller";
                    }
                }
                else{
                    return "Contact Seller"
                }
            }
        },
        methods: {
            SubmitContactSeller(e) {
                this.submitSuccess = false;
                this.submitFailure = false;
                this.isSubmitting = true;

                this.v$.$validate();
                if (this.v$.$error) {
                    this.isSubmitting=false;
                    for (var i = 0; i < this.v$.$errors.length; i++) {
                        console.log(this.v$.$errors[i].$message);
                    }
                    return;
                }

                this.leadObj.leadSource = this.leadSource;
                this.leadObj.honeyPot = this.hpvalue;
                this.leadObj.requestTime = document.getElementById("loading-time").value;
                this.leadObj.boat_serial_number__c = this.hin;
                this.leadObj.boat__c = this.salesforceId;
                this.leadObj.dealer_Number__c = this.selectedDealer.dealerNo;
                this.leadObj.web_Dealer_Name__c = this.selectedDealer.name;

                console.log('number: ' + this.selectedDealer.dealerNo);
                console.log('End point: ' + getEndPoint(leadAPI))
                console.log('Before Lead Post: ' + this.leadObj.dealer_Number__c + '-' + this.leadObj.web_Dealer_Name__c);
                //console.log('boat__c: ' + this.leadObj.boat__c)

                this.axios
                    .post(getEndPoint(leadAPI), this.leadObj)
                    .then((response) => {
                        this.leadID = response.data.id;
                        this.submitSuccess = true;
                        this.submitFailure = false;
                        this.isSubmitting = false;
                    })
                    .catch((error) => {
                        this.submitFailure = true;
                        this.submitSuccess = false;
                        this.isSubmitting = false;
                        console.error("There was an error!", error);
                    });
                e.preventDefault();
            },


            checkForDealers() {

                if (this.isNational) {

                    this.searchRequest.dealer.country = "United States";
                    this.currentBrand = window.BRAND;
                    this.searchRequest.dealer.type = this.currentBrand;
                    this.searchRequest.dealer.zipcode = this.leadObj.postalCode;

                    console.log('request: ' + this.searchRequest.dealer.country);

                    if (this.v$.leadObj.postalCode.$error) {
                        return;
                    }

                    this.axios
                        .post(getEndPoint(searchAPI), this.searchRequest)
                        .then((response) => {

                            let dealers = response.data.dealers.map((item) => {
                                return { value: item, label: item.name };
                            });

                            this.dealerList = [{ value: "Select Dealer" }, ...dealers];

                            console.log('dealersList : ' + this.dealerList)

                            if (this.dealerList && this.dealerList.length > 2) {// one plus the "Select Dealer" that we added
                                this.showDealerSelect = true;
                            }
                            else if (this.dealerList && this.dealerList.length === 2) {
                                this.selectedDealer = this.dealerList[1].value;
                            }
                            //                            console.log("This is the dealer count: " + this.dealerList.length);
                        })
                        .catch((error) => {
                            console.error("There was an error!", error);
                        });
                }
                else {
                    this.selectedDealer = window.DEALER_LOCATION;
                    console.log('in the else: ' + this.selectedDealer.name);
                    console.log('selected number: ' + this.selectedDealer.dealerNo);
                }
            },

            selectDealer(evt) {
                this.selectedDealer = evt;
                console.log('selected name: ' + this.selectedDealer.name);
            }
        },
    };
</script>